export default Mapa;

/** @ngInject */
function Mapa($q) {
  var vm = this;
  var deferred = $q.defer();
  var carregarApiPromise = deferred.promise;

  vm.apiPromise = undefined;
  vm.estavaOffline = false;
  vm.registrarCbCarregarApi = registrarCbCarregarApi;
  vm.obterApi = obterApi;

  function registrarCbCarregarApi(cb) {
    carregarApiPromise = cb;
    deferred.resolve(cb);
  }

  function obterApi() {
    return $q.when(carregarApiPromise).then(carregarApi);
  }

  function carregarApi(cb) {
    return cb();
  }
}



/** WEBPACK FOOTER **
 ** ./common/components/mapa/mapa.service.ts
 **/